// T-ENT-GUION-2 (fiscal r1 · H2): la MISMA condición que el motor (`seccionesDelChat` en
// `worker/src/conectores/entrenamiento.ts`). Copia sin imports a propósito (el panel no depende
// del worker); que las dos digan lo mismo lo ata `worker/test/guion_desde_secciones.test.ts` (V-634).
export function seccionesEnUso(secciones: ReadonlyArray<{ activo: boolean; canal: string; contenido: string }>): boolean {
  return secciones.some((s) =>
    s.activo && (s.canal === "chat" || s.canal === "ambos") && typeof s.contenido === "string" && s.contenido.trim() !== "");
}
